import React from "react";
import {
  Box,
  Button,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";

const FeaturesSection = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mt: { xs: 8, md: 0 },
        mb: { xs: 6, md: 4 },
        px: { xs: 2, md: 4 },
        maxWidth: { xs: "100%", md: "1420px" },
        mx: "auto",
      }}>
      {/* Title */}
      <Typography
        sx={{
          fontFamily: "var(--font-poppins)",
          fontSize: { xs: "28px", md: "36px" },
          fontWeight: 800,
          lineHeight: { xs: 1.25, md: 1.3 },
          color: theme.palette.primary.main,
          mb: { xs: 2, md: 3 },
          textAlign: { xs: "center", md: "left" },
          maxWidth: { xs: "100%", md: "40%" },
        }}>
        Powerful features built for real shipping needs
      </Typography>
      <Typography
        sx={{
          fontFamily: "RethinkSans, sans-serif",
          fontSize: { xs: "16px", md: "20px" },
          color: "#212529",
          mb: { xs: 4, md: 6 },
          textAlign: { xs: "center", md: "left" },
        }}>
        Everything you need, in one simple platform.
      </Typography>

      {/* Cards */}
      <Box
        sx={{
          display: "flex",
          overflowX: { xs: "auto", lg: "visible" },
          gap: { xs: 2, md: 3 },
          px: 0,
          maxWidth: "100%",
          justifyContent: { md: "space-between" },
        }}>
        {[
          {
            title: "Centralize All Your Shipments",
            desc: "Manage all your orders in one place, create shipping labels easily, and save with carrier discounts.",
            img: "/images/ShippingLabel.png",
          },
          {
            title: "Save Time with Automation",
            desc: "Speed up your shipping process by automating label creation, tracking, and carrier selection.",
            img: "/images/SaveTime.png",
          },
          {
            title: "Lower Your Costs Instantly",
            desc: "Access discounted shipping rates from top carriers and reduce your logistics expenses from day one.",
            img: "/images/UpTo83.png",
          },
          {
            title: "Scale Without Limits",
            desc: "Whether you’re shipping 10 or 10,000 orders a day, NestShipper adapts to your growth without extra complexity.",
            img: "/images/RocketUp.png",
          },
        ].map((item, idx) => (
          <Box
            key={idx}
            sx={{
              width: { xs: "246px", md: "266px" },
              height: { xs: "385px", md: "460px" },
              borderRadius: "20px",
              border: "1px solid #f1f1f1",
              backgroundColor: "#fff",
              p: { xs: "27px 31.6px", md: "29px 39.6px" },
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}>
            <Box>
              <Typography
                sx={{
                  fontFamily: "var(--font-poppins)",
                  fontSize: { xs: "16px", md: "18px" },
                  fontWeight: 800,
                  color: theme.palette.primary.main,
                  mb: { xs: 1, md: 2 },
                }}>
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "RethinkSans, sans-serif",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.5,
                  color: "#212529",
                }}>
                {item.desc}
              </Typography>
            </Box>
            <Box
              sx={{
                width: { xs: "182.7px", md: "190.9px" },
                height: { xs: "142px", md: "148.4px" },
                mt: idx === 1 ? -4 : 0,
                alignSelf: "center",
              }}>
              <Image
                src={item.img}
                alt={item.title}
                width={300}
                height={300}
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FeaturesSection;
